import { createContext, useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Agreement from '../../components/creditInfoForm/steps/agreement'
import { useGlobalContext } from '../globalContext';
import useStepThreeValues from './stepThreeValues';

export const IdentificationStepsContext = createContext(null);

export function IdentificationStepsContextProvider({ children }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const {
    globalData: { status },
  } = useGlobalContext();
  const { stepThreeValues, setStepThreeValues } = useStepThreeValues();

  const [redirectUrl, setRedirectUrl] = useState(null);

  const [activeStep, setActiveStep] = useState({
    id: 1,
    component: <Agreement />,
    route: `/identification/agreement/${i18n.language}`,
  });


  const steps = useMemo(
    () => [
      {
        id: 1,
        title: t('confirmationStep1'),
        disabled: true,
        route: `/identification/agreement/${i18n.language}`,
      },
      {
        id: 2,
        title: t('identificationStep2'),
        disabled: status !== 'approved',
        route: `/identification/Identomat/${i18n.language}`,
      },
      {
        id: 3,
        title: t('identityInformation3'),
        disabled: status !== 'approved',
        route: `/identification/step/3`,
      },
      {
        id: 4,
        title: t('identityInformation6'),
        disabled: status !== 'approved',
        route: `/identification/step/4`,
      },
    ],
    [status, i18n.language, t]
  );


  const nextStep = () => {
    steps.forEach((step) => {
      if (step.id === activeStep.id + 1) {
        history.push(step.route);
      }
    });
  };

  const prevStep = () => {
    if (activeStep.id - 1 !== 2) {
      steps.forEach((step) => {
        if (step.id === activeStep.id - 1) {
          history.push(step.route);
        }
      });
    }
  };

  return (
    <IdentificationStepsContext.Provider
      value={{
        activeStep,
        nextStep,
        prevStep,
        redirectUrl,
        setRedirectUrl,
        steps,
        setActiveStep,
        stepThreeValues,
        setStepThreeValues,
      }}
    >
      {children}
    </IdentificationStepsContext.Provider>
  );
}

export function useIdentificationStepsContext() {
  const value = useContext(IdentificationStepsContext);
  if (!value) {
    throw new Error('Identification Steps context Provider is not defined');
  }
  return value;
}
